import { useSelector } from "react-redux";
import { getMessagePreviewById } from "utils/message";
import { handleScrollIntoView } from "utils/view";

const getLocale = ({ settingsData }) => settingsData.locale;
const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;

const TextMessage = ({ id, content, delivered, time, replyId, status }) => {
  const locale = useSelector(getLocale);
  const selectedConversation = useSelector(getSelectedConversation);

  const handleShowRepliedMessage = () => {
    handleScrollIntoView(replyId);
  };

  return (
    <div
      // data-tool-tip-bottom-right={time}
      data-id={id}
      className="conv__body__body__inner__msgright__inner__bubble flex flex-ai-e flex-jc-sb"
    >
      <div className="conv__body__body__inner__msgright__inner__bubble__text">
        {replyId && (
          <div
            dir="auto"
            className="conv__body__body__inner__msgright__inner__bubble__replied_msg"
            onClick={handleShowRepliedMessage}
          >
            <span>
              {getMessagePreviewById(replyId, selectedConversation, locale)}
            </span>
          </div>
        )}
        <div dir="auto">{content}</div>

        {/*  */}
      </div>
    </div>
  );
};

export default TextMessage;
